import {Toaster as Sonner, toast} from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({...props}: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      position="top-center"
      mobileOffset={{
        top: "calc(env(safe-area-inset-top) + 1rem)",
        right: "1rem",
        bottom: "1rem",
        left: "1rem",
      }}
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          error: "!bg-destructive-muted !text-destructive !border-destructive/25",
          success: "!bg-success-muted !text-success !border-success/25",
          warning: "!bg-warning-muted !text-warning !border-warning/25",
          info: "!bg-info-muted !text-info !border-info/25",
        },
      }}
      {...props}
    />
  );
};

export {Toaster, toast};
